<template>
  <div class="delivery-batch">
    <MainBackButton :forceHome="true" />
    <p
      class="title is-4 has-text-success has-text-left"
      style="padding-top: 15px; margin-bottom:2px"
    >
      <span style="padding-left:55px">Setup Batch</span>
      <span
        class="button icon is-medium is-pulled-right is-danger is-outlined"
        style="margin-right:12px; margin-top:-5px; height:32px; padding:4px"
        @click="resetBatch"
      >
        <i class="fa fa-redo" />
      </span>
      <span
        class="button is-pulled-right is-link is-outlined"
        style="margin-right:12px; margin-top:-5px; height:32px; padding:4px"
        @click="goToDelivery"
      >Delivery</span>
    </p>

    <div class="container">
      <div class="notification">
        <div class="field" v-if="batchReady">
          <div class="control">
            <button
              class="button is-danger is-fullwidth is-rounded"
              @click="dispatchVehicles"
            >Dispatch Vehicles</button>
          </div>
        </div>
        <!-- Business Type and Name (also address) -->
        <div class="field tags has-addons" v-if="businessName">
          <span class="single-line no-scrollbar" style="padding-bottom:10px">
            <span class="tag is-info is-medium">
              <i class="fa fa-store-alt" />
              &nbsp;{{ businessType }}
            </span>
            <span class="tag is-white is-medium has-text-link">
              <a :href="businessMap" target="_blank">{{ businessName }}</a>&nbsp;
            </span>
          </span>
        </div>

        <div class="field tags has-addons">
          <span class="single-line" style="padding-bottom:10px;">
            <span class="tag is-warning is-medium">Started {{ startedAt }}</span>
            <span class="tag is-white is-medium">{{ orders.length }} Orders</span>
            <span class="tag is-success is-medium has-text-weight-semibold">
              <i class="fa fa-check-circle" />
              &nbsp;{{ completeOrders }}
            </span>
            <span v-if="!batchReady" class="tag is-danger is-medium has-text-weight-semibold">
              <i class="fa fa-frown" />
              &nbsp;{{ incompleteOrders }}
            </span>
          </span>
        </div>

        <div class="field tags has-addons" v-if="businessName">
          <span class="single-line">
            <span
              class="tag is-medium has-text-weight-semibold"
              :class="batchStateClass"
              @click="dispatchVehicles"
            >
              <!-- <span v-if="batchReady">
                <i class="fa fa-paper-plane" />&nbsp;
              </span>-->
              <i class="fa fa-shuttle-van" />
              &nbsp;{{ vehicleCount }}
            </span>
            <span class="tag is-medium is-white plus-minus" @click="addVehicle(-1)">
              <i class="fa fa-minus-circle" />
            </span>
            <span class="tag is-medium is-white plus-minus" @click="addVehicle(1)">
              <i class="fa fa-plus-circle" />
            </span>
            <span
              v-for="(v, idx) in vehicles"
              :key="idx"
              class="tag is-medium has-text-weight-semibold has-text-white"
              style="width:28px"
              :style="vehicleColor(v)"
            >{{vehicleOrderCount(idx)}}</span>
          </span>
        </div>

        <div v-if="unassignedOrders > 0" style="padding-top:12px" @click="toggleMap">
          <span class="tag is-warning has-text-weight-medium" style="height:45px">
            {{ unassignedOrders }}&nbsp; Unassigned deliveries!
            <br />Click the black ⚫️ on the map to assign.
          </span>
        </div>

        <div style="height:6px" />
        <!-- orders -->
        <div>
          <label class="label has-text-link">Order List</label>
          <div class="field has-addons order" v-for="(o, idx) in orders" :key="o.ref">
            <div class="control">
              <a class="button is-dark has-text-weight-medium" @click="setRef(o, idx)">
                <i class="fa fa-receipt" />
                &nbsp;{{ o.ref }}
              </a>
            </div>
            <div class="control">
              <a
                v-if="notOkay(o)"
                class="button is-info has-text-weight-medium"
                v-clipboard:copy="shortLinkMessage(o)"
                @click="sendOrder(o)"
                :class="{ 'is-danger': !o.phone_number || o.phone_number.length < 8 }"
              >
                <i class="fa fa-paper-plane" />&nbsp;Send
              </a>
              <a
                v-else
                class="button is-success has-text-weight-medium"
                v-clipboard:copy="shortLinkMessage(o)"
                @click="sendOrder(o)"
              >
                <i class="fa fa-shuttle-van" />&nbsp;Okay
              </a>
            </div>
            <div class="control">
              <a class="button is-warning has-text-weight-medium">
                <i class="fa fa-phone" />
              </a>
            </div>
            <div class="control">
              <input
                class="input is-warning"
                v-model="o.phone_number"
                type="number"
                placeholder="Mobile"
              />
            </div>
            <div class="control">
              <a
                class="button has-text-weight-medium"
                :class="{ 'is-success': o.dropoff, 'is-danger': !o.dropoff }"
                style="width: 35px"
                @click="showDropoff(o)"
              >
                <i class="fa fa-map-marker-alt" />
              </a>
            </div>
          </div>
        </div>
        <div style="height:5px" />
        <span class="buttons is-centered">
          <span class="button is-rounded is-success" @click="addOrder">
            <i class="fa fa-plus" />&nbsp;Add
          </span>
          <span class="button is-rounded is-link" @click="updateOrders">
            <i class="fa fa-sync" :class="{ 'fa-spin': updating }" />&nbsp;Update
          </span>
          <span v-if="mapToggle" class="button is-rounded is-warning" @click="toggleMap">
            <i class="fa fa-list-ul" />&nbsp;List
          </span>
          <span v-else class="button is-rounded is-info" @click="toggleMap">
            <i class="fa fa-map-marked-alt" />&nbsp;Map
          </span>
        </span>

        <span
          v-show="showMap"
          class="button is-fullwidth is-warning is-rounded"
          @click="toggleMap"
        >List View</span>

        <div v-if="showMap" style="padding-top:10px; margin-bottom:-6px;">
          <!-- style="margin-top:-10px" -->
          <span v-if="settingVehicle" class="single-line tags set-vehicle">
            <span class="tag is-black" style="width:28px; height:28px" @click="setVehicle(-1)">
              <i class="fa fa-question fa-lg" />
            </span>
            <span
              v-for="(v, idx) in vehicles"
              :key="idx"
              class="tag has-text-white"
              style="width:28px; height:28px"
              :style="vehicleColor(v)"
              @click="setVehicle(idx)"
            >
              <i class="fa fa-shuttle-van fa-lg" />
            </span>
          </span>
          <div v-if="!settingVehicle" style="padding-top: 2px; height:35px">
            <span>Tap delivery dot ⚫️🔵🔴 to assign vehicle</span>
          </div>
        </div>
      </div>
    </div>

    <BatchDeliveryMap v-show="showMap" />
  </div>
</template>

<script>
import EventBus from "../eventBus";
import $Scriptjs from "scriptjs";
import MainBackButton from "@/components/MainBackButton.vue";
import BatchDeliveryMap from "@/components/BatchDeliveryMap.vue";
import geo from "@/geo";
const shortid = require("shortid");

export default {
  name: "DeliveryBatch",
  components: {
    MainBackButton,
    BatchDeliveryMap
  },
  data() {
    return {
      orders: [],
      startedAt: null,
      vehicleCount: 1,
      businesses: [],
      drivers: [],
      passengers: [],
      workflowType: "",
      workflowID: "",
      businessID: "",
      prompt: false,
      mapToggle: false,
      updating: false,
      colors: [
        "#1f78b4",
        "#33a02c",
        "#e31a1c",
        "#ff7f00",
        "#a6cee3",
        "#b2df8a",
        "#fb9a99",
        "#fdbf6f"
      ],
      settingVehicle: false,
      settingRef: null,
      showMap: false
    };
  },
  computed: {
    batchReady() {
      var unassigned = this.orders.filter(o => o.vehicle === -1);
      if (unassigned.length === 0) return true;
      return false;
    },
    batchStateClass() {
      if (this.batchReady) return "is-success";
      return "is-danger";
    },
    initialisedAt() {
      if (this.orders && this.orders.length > 0) {
        return this.hhmmTime(this.orders[0].initialised_at);
      }
      return "Unknown";
    },
    vehicles() {
      return this.colors.slice(0, this.vehicleCount);
    },
    completeOrders() {
      var complete = this.orders.filter(o => o.dropoff && o.vehicle > -1);
      if (!complete) return 0;
      return complete.length;
    },
    incompleteOrders() {
      var incomplete = this.orders.length - this.completeOrders;
      return incomplete;
    },
    unassignedOrders() {
      var unassigned = this.orders.filter(o => o.dropoff && o.vehicle === -1);
      return unassigned.length;
    },
    totalPrice() {
      var cash = parseInt(this.cash || 0);
      var tukpay = parseInt(this.tukpay || 0);
      return cash + tukpay;
    },
    deliveryWorkflowID() {
      if (this.$store.getters.getDeliveryDispatcherRole) {
        return this.$store.getters.getDeliveryDispatcherRole.workflow_id;
      }
      return null;
    },
    business() {
      if (this.$store.getters.getDeliveryDispatcherRole) {
        return this.$store.getters.getDeliveryDispatcherRole.business;
      }
      return null;
    },
    businessName() {
      if (this.business) return this.business.name;
      return null;
    },
    businessType() {
      if (this.business) return this.business.business_type;
      return null;
    },
    businessNameAndType() {
      return `${this.businessName} (${this.businessType})`;
    },
    businessMap() {
      if (!this.business) return null;
      var lat = this.business.lat;
      var lon = this.business.lon;
      return `http://www.google.com/maps/place/${lat},${lon}`;
    },
    newDelivery() {
      return this.deliveries.filter(d => !d.dropoff).length > 0;
    }
  },
  mounted() {
    var googlePlacesURL = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBYOwhqakcxLQQLpljhkug2WsNSA02cqss&libraries=places`;
    $Scriptjs(googlePlacesURL, () => this.initGoogle());
    this.initialiseOrders();
    EventBus.$on("SELECT_BATCH_ORDER", ref => {
      console.log("SELECT BATCH ORDER form", ref);
      this.settingVehicle = true;
      this.settingRef = ref;
      // this.$nextTick(() => this.scrollToBottom());
    });
    EventBus.$on("DESELECT_BATCH_ORDER", () => (this.settingVehicle = false));
    EventBus.$on("BATCH_SCROLL_BOTTOM", () => this.scrollToBottom());
    EventBus.$on("DISPATCH_DELIVERY_VEHICLE", i => {
      this.$swal.close();
      this.$router.push(`/delivery?vehicle=${i}`);
    });
  },
  activated() {
    this.updateOrders();
    this.pickup = {
      id: "special_stop",
      name: this.business.name, // this.businessNameAndType
      lat: this.business.lat,
      lon: this.business.lon
    };
  },
  methods: {
    notOkay(o) {
      if (o.vehicle === -1) return true; // vehicle not set
      if (!o.dropoff) return true; // no dropoff
      return false;
    },
    vehicleOrderCount(idx) {
      return this.orders.filter(o => o.vehicle === idx).length;
    },
    dispatchVehicles() {
      if (!this.batchReady) {
        var msg = `Vehicles not ready for dispatch.<br>Please assign all orders.`;
        this.warningAlert(msg);
      } else {
        this.$swal({
          title: "Dispatch Vehicles",
          html: this.selectVehicleList(),
          showConfirmButton: false
        });
      }
    },
    selectVehicleList() {
      var html = ``;
      for (var i = 0; i < this.vehicleCount; i++) {
        var color = this.colors[i];
        var orderCnt = this.vehicleOrderCount(i);
        var row = `<p style="padding-bottom:5px"><span class="button" onclick="dispatchDeliveryVehicle(${i})"><i class="fa fa-shuttle-van" style="color:${color}"></i>&nbsp;&nbsp;${orderCnt} Deliveries</span>`; // </p>`;
        var vehiclesCompleted = this.$store.state.batchVehiclesCompleted;
        if (vehiclesCompleted.includes(i)) {
          row += `&nbsp;<span class="button" style="background-color:pink">Dispatched</span>`;
        }
        html = html + (row + "</p>"); // remember to close the tag
      }
      return html;
    },
    setVehicle(idx) {
      console.log("setVehicle", idx);
      var o = this.orders.find(o => o.ref === parseInt(this.settingRef));
      if (!o) alert(`Order ref ${this.settingRef} doesn't exist`);
      o.vehicle = idx;
      this.settingRef = null;
      this.settingVehicle = false;
      this.save();
      this.forceUpdateOrders();
      this.updateMap();
    },
    updateMap() {
      EventBus.$emit("UPDATE_BATCH_DELIVERY_MAP");
    },
    save() {
      if (this.vehicleCount === 1) {
        this.orders.forEach(o => (o.vehicle = 0)); // if only 1 vehicle, assign
      }
      console.log("setBatchOrders", this.orders);
      this.$store.commit("setBatchOrders", this.orders);
    },
    vehicleColor(v) {
      return `background-color: ${v}`;
    },
    addVehicle(n) {
      if (this.blockVehicleRemoval(n)) return;
      this.vehicleCount += n;
      if (this.vehicleCount < 1) this.vehicleCount = 1;
      if (this.vehicleCount > this.colors.length) {
        this.vehicleCount = this.colors.length;
        this.warningAlert(
          "You've reached the maximum vehicle limit.<br><br>Please contact TUK for assistance."
        );
      }
      this.$store.commit("setBatchVehicleCount", this.vehicleCount);
    },
    blockVehicleRemoval(n) {
      if (n > -1) return false;
      var orders = this.orders.filter(o => o.vehicle === this.vehicleCount + n);
      if (orders.length > 0) {
        this.warningAlert(
          "Vehicle has orders on it. Please move orders to another vehicle first."
        );
        return true;
      }
      return false;
    },
    initialiseOrders() {
      this.vehicleCount = this.$store.state.batchVehicleCount;
      if (this.$store.state.batchOrders) {
        this.orders = this.$store.state.batchOrders;
      } else {
        this.orders = [{ ref: 1, link: shortid.generate(), vehicle: -1 }];
        this.$store.commit("startBatch", new Date());
      }
      var dt = new Date(this.$store.state.batchStartedAt);
      this.startedAt = this.hhmmTime(dt);
    },
    toggleMap() {
      this.save();
      if (this.mapToggle) {
        this.scrollToTop();
      } else {
        this.scrollToBottom();
      }
    },
    scrollToTop() {
      this.showMap = false;
      window.scrollTo(0, 0);
      this.mapToggle = false;
    },
    scrollToBottom() {
      this.showMap = true;
      this.$nextTick(() => {
        window.scrollTo(0, document.body.scrollHeight);
        EventBus.$emit("OPEN_BATCH_DELIVERY_MAP");
      });
      this.mapToggle = true;
    },
    updateOrders() {
      this.updating = true;
      setTimeout(() => {
        this.save();
        this.updateMap();
        this.updating = false;
      }, 3000); // save it after a while...
      this.orders.forEach(o => {
        if (!o.dropoff && this.validPhoneNumber(o, true)) {
          this.updateOrder(o);
        }
      });
    },
    updateOrder(o, showLoader) {
      console.log("update order", o.ref);
      // given phone number get home address of user, set as dropoff
      if (showLoader) var loader = this.loadingDots("cyan");
      this.$store
        .dispatch("getUserAddress", o.phone_number)
        .then(res => {
          console.log("getUserAddress", res);
          o.dropoff = res.data;
          o.map = this.googleMapURL(o.dropoff);
          this.forceUpdateOrders();
        })
        .catch(err => console.error(err))
        .finally(() => {
          if (showLoader) loader.hide();
        });
    },
    googleMapURL(coords) {
      var lat = coords.lat;
      var lon = coords.lon;
      return `http://www.google.com/maps/place/${lat},${lon}`;
    },
    forceUpdateOrders() {
      this.orders.push(null);
      this.orders.pop();
    },
    resetBatch() {
      this.$swal({
        title: "Are you sure you want to reset?",
        text: "This will create a new batch",
        showCancelButton: true,
        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("cancel")
      }).then(val => {
        if (val.value) {
          this.$store.commit("setBatchOrders", null);
          this.$store.commit("setBatchVehicleCompleted", null);
          location.reload();
        }
      });
    },
    shortLink(o) {
      var url = process.env.VUE_APP_HOST;
      return `${url}/q/${o.link}`;
    },
    orderConfirmationLink(o) {
      var user = this.userID(); // send notification back to this user
      var type = this.business.business_type;
      var name = this.business.name;
      var lat = this.business.lat;
      var lon = this.business.lon;
      var country = this.business.country;
      return `/order_confirmation/${o.phone_number}?created_by=${user}&workflow_id=${this.deliveryWorkflowID}&business_type=${type}&business_name=${name}&lat=${lat}&lon=${lon}&country=${country}`;
    },
    validPhoneNumber(o, hideAlert) {
      var n = this.orders.filter(x => x.phone_number === o.phone_number);
      if (n.length > 1) {
        var msg = `Please enter a new phone number. This one already has a delivery.`;
        if (!hideAlert) this.warningAlert(msg);
        return false;
      }
      if (!o.phone_number || o.phone_number.length < 8) {
        if (!hideAlert) this.warningAlert("Please enter a valid phone number");
        return false;
      }
      return true;
    },
    sendOrder(o) {
      this.save();
      console.log("sendOrder", o);
      if (!this.validPhoneNumber(o)) return;
      var longLink = this.orderConfirmationLink(o);
      this.shortenLink(longLink, o.link, 24 * 60); // 24 hours validity
      //   var link = this.orderConfirmationLink(o);
      var link = this.shortLink(o);
      this.$swal({
        title: "Paste to share 🥳",
        html: `<strong><i class="fa fa-receipt"></i> ${o.ref}</strong>&nbsp;-
        Order confirmation link<br>copied to clipboard!<br><br><a href='${link}'>${link}</a>`,
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "<i class='fa fa-share-alt'></i> Share",
        cancelButtonText: "<i class='fa fa-sms'></i> SMS",
        cancelButtonColor: "#8565c4"
      }).then(val => {
        console.log("sendOrder", val);
        if (val.value) {
          this.shareOrder(o);
        }
        if (val.dismiss === "cancel") {
          this.smsOrder(o);
        }
      });
    },
    shareOrder(o) {
      if (!navigator.share) {
        console.log("native sharing not supported by this device");
        this.warningAlert(
          `Sharing not supported by this device.<br><br>Send as SMS or paste into a chat.`
        );
        return;
      }
      navigator
        .share({
          //   title: "TUK Delivery Confirmation",
          text: this.$t("delivery.share-message"), //"TUK Delivery📦 Click link to confirm delivery details!🍱🥂",
          url: this.shortLink(o)
        })
        .then(() => console.log("Successful share"))
        .catch(err => console.log("Error sharing", err));
    },
    shortLinkMessage(o) {
      var link = this.shortLink(o);
      return `${this.$t("delivery.share-message")} ${link}`;
    },
    smsOrder(o) {
      var msg = this.shortLinkMessage(o);
      this.sendSMS(msg, o.phone_number);
      var txt = `Please check customer has received SMS in a minute. If not received send via chat.`;
      this.thankYou(txt);
    },
    showDropoff(o) {
      if (!o.phone_number) {
        alert("Enter phone number");
        return;
      }
      if (!o.dropoff) return this.updateOrder(o, true); // check for address
      console.log("dropoff", o);
      var d = o.dropoff;
      this.$swal({
        html: `<div style='text-align:left'>
        <i class="fa fa-receipt"></i>&nbsp;${o.ref} - 
        <i class="fa fa-phone"></i>&nbsp;<strong>${o.phone_number}</strong><br><br>
        <strong>${d.name}</strong><br>${d.address}<br><br>
        <i class="fa fa-pencil-alt"></i>&nbsp;Notes: ${o.dropoff.notes}<br><br>
        <a href="${o.map}" target="_blank"><i class="fa fa-map-marked-alt"></i>&nbsp;Google Map</a></div>`,
        showConfirmButton: false
      });
      this.updateOrder(o);
      this.updating = true;
      setTimeout(() => {
        this.save();
        this.updateMap();
        this.updating = false;
      }, 1000);
    },
    goToDelivery() {
      this.$router.push("/delivery").catch(err => {
        console.error("push_delivery err:", err);
        location.reload();
      });
    },
    deleteDropoff(idx) {
      if (this.newDelivery) {
        this.$swal("Finish current dropoff first");
        return;
      }
      this.prompt = false;
      var i = this.revertIndex(idx);
      this.deliveries[i].dropoff = null;
    },
    addOrder() {
      var lastRef = this.orders[this.orders.length - 1].ref;
      var obj = {
        ref: lastRef + 1,
        link: shortid.generate(),
        vehicle: -1
      };
      // if (this.vehicleCount === 1) obj.vehicle = 0;
      this.orders.push(obj);
      this.save();
    },
    ref(d) {
      return d.ref;
    },
    setRef(o, idx) {
      this.$swal({
        // html: "Set reference number<br>Or delete order",
        input: "number",
        inputPlaceholder: "Reference Number",
        showCancelButton: true,
        confirmButtonText: `<i class='fa fa-receipt'></i>&nbsp;Set Reference Number`,
        cancelButtonText: `<i class='fa fa-bomb'></i>&nbsp;Delete Order`,
        cancelButtonColor: "red",
        reverseButtons: true,
        inputValidator: val => {
          if (!val) return "Input a reference number or tap outside to close";
          var exists = this.orders.find(o => o.ref == val);
          if (exists) return "Reference number is taken";
        }
      }).then(val => {
        console.log("setRef", val);
        if (val.value) {
          o.ref = parseInt(val.value);
          this.save();
          this.updateMap();
        } else if (val.dismiss === "cancel") {
          if (this.orders.length === 1) this.initialiseOrders();
          else this.orders.splice(idx, 1);
        }
      });
    },
    addDelivery(p) {
      var delivery = {
        passengerID: p.value,
        passengerName: p.key
      };
      this.deliveries.push(delivery);
    },
    deleteDelivery(idx) {
      var i = this.revertIndex(idx);
      this.$swal({
        title: "Delete this dropoff?",
        showCancelButton: true,
        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("no")
      }).then(val => {
        if (val.value) {
          this.deliveries.splice(i, 1);
          this.passengers = []; // clear passengers
          this.clearPassenger();
        }
      });
    },
    setDropoff(stop, mapURL) {
      var d = this.deliveries.find(d => !d.dropoff);
      d.dropoff = stop;
      d.map = mapURL;
      //   var i = this.deliveries.length - 1; // index of last element
      //   this.deliveries[i].dropoff = stop;
      //   this.deliveries[i].map = mapURL;
      this.deliveries = JSON.parse(JSON.stringify(this.deliveries)); // force update
      this.clearPassenger();
      this.prompt = true;
    },

    lookupPassengers(e) {
      this.prompt = false;
      var text = e.target.value;
      this.passengerName = text;
      console.log("lookupPassengers", text);
      if (text.length < 3) {
        this.passengers = [];
        return; // don't check until at least 3 letters long
      }
      if (text[0] === "+") {
        this.passengerID = text; // phone number can act as temporary passenger ID
        console.log("passengerID", text);
        return; // entering phone number don't look up users
      }
      if (text[0] === "0" && text.length > 5) {
        this.passengerID = text; // phone number can act as temporary passenger ID
        console.log("passengerID", text);
        return; // entering phone number don't look up users
      }
      this.$store
        .dispatch("autocompleteUsers", this.trim0(text))
        .then(res => {
          if (res.data) this.passengers = res.data;
          else this.passengers = [];
        })
        .catch(err => console.error("userAutocomplete", err));
    },
    trim0(s) {
      if (s[0] === "0") return s.substring(1); // remove leading 0
      return s;
    },
    createStop(place) {
      return {
        id: "special_stop",
        name: place.name || place.formatted_address,
        lat: place.geometry.location.lat(),
        lon: place.geometry.location.lng()
      };
    },
    dropoffMap(d) {
      if (!d.dropoff) return null;
      window.location.href = d.map;
    },
    dropoffName(d) {
      if (!d.dropoff) return false;
      return d.dropoff.name;
    },
    enterDropoff() {
      this.initGoogle();
      this.$refs.autocomplete.focus();
    },
    initGoogle() {
      this.autocomplete = new google.maps.places.Autocomplete(
        this.$refs.autocomplete,
        {
          types: []
          // componentRestrictions: { country: "th" }
        }
      ); // uses all, options are ["address", "establishment", "geocode"]
      this.geolocate(); // Bias autocomplete to the user geolocation,

      this.autocomplete.addListener("place_changed", () => {
        var place = this.autocomplete.getPlace();
        this.console(`selected google location: ${place.name}`, place);
        this.addressName = place.name;
        this.fullAddress = place.formatted_address;
        this.url = place.url;
        this.place = place;
        var stop = this.createStop(place);
        this.setDropoff(stop, place.url);
        // if (!this.pickup) {
        //   this.pickup = stop;
        //   this.pickupURL = place.url;
        // } else {
        //   this.dropoff = stop;
        //   this.dropoffURL = place.url;
        // }
        document.getElementById("delivery-dispatch-google").focus();
      });
    },
    // Bias autocomplete to the user geolocation,
    geolocate() {
      if (!navigator.geolocation) return;
      navigator.geolocation.getCurrentPosition(position => {
        var coords = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        var circle = new google.maps.Circle({
          center: coords,
          radius: position.coords.accuracy
        });
        this.autocomplete.setBounds(circle.getBounds());
      });
    },
    getFare(n) {
      //   var n = this.deliveries.length; // split fare n ways for batch delivery
      if (!this.tukpay) this.tukpay = 0;
      if (!this.cash) this.cash = 0;
      var price = parseInt(this.tukpay) + parseInt(this.cash);
      var discount = parseInt(this.tukpay);
      return {
        version: "v1",
        price: parseInt(price / n),
        discount: parseInt(discount / n),
        cash: parseInt(this.cash / n),
        tukpay: parseInt(this.tukpay / n)
      };
    },
    getHypotheticalFare() {
      var n = this.deliveries.length; // split fare n ways for batch delivery
      var tukpay = this.tukpay;
      var cash = this.cash;
      if (!tukpay) tukpay = 0;
      if (!cash) cash = 0;
      var price = parseInt(tukpay) + parseInt(cash);
      var discount = parseInt(tukpay);
      return {
        version: "v1",
        price: parseInt(price / n),
        discount: parseInt(discount / n),
        cash: parseInt(cash / n),
        tukpay: parseInt(tukpay / n)
      };
    },
    parseScheduledTime() {
      if (!this.date) {
        return this.time.toISOString(); // time will always be set currently
      }
      // actually could let user not enter and default to NOW, not scheduled
      var dt = this.date;
      dt.setHours(this.time.getHours());
      dt.setMinutes(this.time.getMinutes());
      if (dt < new Date()) {
        alert("Scheduled time cannot be in the past!!");
        return null; // can't be in the past
      }
      return dt.toISOString();
    },
    // copied from DeliveryDispatch.vue, but not used here...
    confirmDelivery() {
      var fare = this.getFare(1);
      this.$swal({
        title: "Confirm Delivery",
        html: `Create <strong>${this.deliveries.length}</strong> Orders Now<br><br>
        Total Price: <strong>฿${fare.price}</strong>
        <br>Cash ฿${fare.cash} + TukPay ฿${fare.tukpay}`,
        showCancelButton: true,
        confirmButtonText: this.$t("okay"),
        cancelButtonText: this.$t("cancel")
      }).then(val => {
        if (val.value) this.createDelivery();
      });
    },
    createDelivery() {
      this.pickup = {
        id: "special_stop",
        name: this.business.name,
        lat: this.business.lat,
        lon: this.business.lon
      };
      var loader = this.loadingDots();
      this.deliveries.forEach((d, i) => {
        console.log(`createDelivery ${i}`, d);
        this.createTransaction(d);
      });
      setTimeout(() => loader.hide(), 2000);
    },
    tripDistance(d) {
      var dist = geo.distanceToUserInMeters(this.pickup, d.dropoff);
      var drivingDist = Math.round(dist * 1.25); //
      this.console(`tripDistance ${dist} (${drivingDist})`);
      return drivingDist;
    },
    createTransaction(d) {
      var delivery = {
        type: this.businessType,
        business_name: this.businessName,
        workflow_id: this.deliveryWorkflowID
      };
      var obj = {
        type: "delivery",
        pickup_stop: this.pickup,
        dropoff_stop: d.dropoff,
        fare: this.getFare(this.deliveries.length), // split fare n ways
        ref: d.ref, // reference number
        delivery: delivery
      };
      obj.fare.distance = this.tripDistance(d);
      var role = this.$store.getters.getDeliveryDispatcherRole; // should not be null
      //   var loader = this.loadingDots();
      this.$store
        .dispatch("createTransaction", {
          workflow_type_name: "Delivery", //role.workflowType, << set this based on the driverID?
          workflow_id: "", //role.workflowID, << set this based on the driverID?
          business_id: role.business_id, // restaurant business ID
          created_by: d.passengerID,
          handled_by: this.driverID,
          data: obj
        })
        .then(() => {
          this.$swal({
            title: `Deliveries are on their way! Please confirm with the driver 🙌🏽`, //this.$t("transport.waiting-for-confirmation"),
            showConfirmButton: false,
            timer: 2000
          });
        })
        .catch(err => this.apiError(err));
      // .finally(() => loader.hide());
    }
  }
};
</script>

<style scoped>
.notification {
  padding: 1rem;
  padding-bottom: 8px;
}
label.label {
  margin-bottom: 0;
}
.column {
  padding-bottom: 0;
}
.tag {
  padding: 0 6px;
}
.tags {
  margin-bottom: 0;
}
.single-line {
  white-space: nowrap;
  overflow: auto;
  margin-bottom: -10px;
  display: inline-block;
}
a.button {
  padding: 5px 5px;
}
.order {
  margin-bottom: 6px;
}
.plus-minus {
  width: 30px;
}
.set-vehicle {
  /* padding-top: 4px; */
  padding-bottom: -8px;
  margin-bottom: -8px;
}
</style>
